<template>
  <div class="comp-xl-select-icon">
    <jw-tooltip
      position="rt"
      :content-style="{
        width: '510px',
        maxWidth: '510px',
        maxHeight: '375px',
        overflow: 'hidden',
        padding: 0,
        borderRadius: '8px',
        // border: '1px solid #ccc'
        boxShadow: '0 2px 8px rgba(0,0,0,.15)'
      }"
      :arrow-style="{ border: '1px solid #ccc' }"
      trigger="click"
      v-model:popup-visible="visible"
      background-color="white"
    >
      <template #content>
        <div class="icon-content scrollbar-style-config">
          <div @click="chooseIcon(icon)" v-for="(icon, index) in icons" :key="index" :class="{ 'icon-box': true, checked: _selectIcon == icon }">
            <component :is="icon" class="icon-component" color="rgb(115, 125, 138)" />
          </div>
        </div>
        <div class="icon-btn">
          <jw-button size="small" @click="closeSelect" style="margin-right: 10px">{{ $t('取消') }}</jw-button>
          <jw-button @click="handleSelect" :disabled="_selectIcon === null" size="small" type="primary"> {{ $t('确定') }}</jw-button>
        </div>
      </template>
      <div class="empty-icon" v-if="!selectIcon">
        <icon-plus size="32" />
      </div>
      <div class="empty-icon select-icon" v-else>
        <component :is="selectIcon" class="icon-component" color="rgb(115, 125, 138)" />
      </div>
    </jw-tooltip>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { icons } from '@/utils/icons';
const _selectIcon = ref(null); // 本次操作选中的图标
const selectIcon = ref(null); //  组件中选中的图标
const emits = defineEmits(['update:modelValue']);
const props = defineProps(['modelValue']);

watch(
  () => props.modelValue,
  () => {
    _selectIcon.value = props.modelValue;
    selectIcon.value = props.modelValue;
  },
  {
    deep: true,
    immediate: true
  }
);

const visible = ref(false);
const chooseIcon = (icon) => {
  if (_selectIcon.value == icon) _selectIcon.value = null;
  else _selectIcon.value = icon;
};
const handleSelect = () => {
  selectIcon.value = _selectIcon.value;
  visible.value = false;
  emits('update:modelValue', _selectIcon.value);
};
const closeSelect = () => {
  _selectIcon.value = selectIcon.value;
  visible.value = false;
};
</script>
<style scoped lang="less">
@import './xl-select-icon.less';
</style>
